import { SET_CE_REPORTING_LIST } from "../../Actions/ActionConstants";

const CEReportListReducer = (state = null, action) => {
    if (action.type === SET_CE_REPORTING_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default CEReportListReducer
